import { useState } from 'react'

import { CustomCellEditorProps } from 'ag-grid-react'

import { SearchSelect } from '@fortem-monorepo/react-ui'

import { useTradersQuery } from '@/react-query/queries/static'

export interface TraderIdCellEditorProps extends CustomCellEditorProps<{
  trader_id: number | null
  client_id?: number | null
}> {}

export const TraderIdCellEditor: React.FC<TraderIdCellEditorProps> = ({
  value,
  onValueChange,
  node,
  stopEditing,
}) => {
  const [open, setOpen] = useState(true)

  const client_id = node.data?.client_id

  const query = useTradersQuery({ org_id: client_id, is_internal: client_id ? false : true })

  return (
    <div className={'flex items-center h-full!'}>
      <SearchSelect
        className={'text-xs ag-custom-component-popup w-full min-w-auto! border-0!'}
        open={open}
        setOpen={setOpen}
        showNone={'None'}
        setValue={(val) => {
          onValueChange(val !== null ? parseInt(val) : null)
          stopEditing()
        }}
        value={value?.toString() ?? ''}
        options={query.data?.map((c) => ({
          label: c.label,
          value: c.value?.toString(),
        }))}
      />
    </div>
  )
}
